import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import { putViaje } from "../helpers/rutaViajes";
import { getMetodos } from "../helpers/rutaMetodos"; // 👈 importar


export default function ModalFormViajePago({ viaje, show, handleClose }) {
  const [form, setForm] = useState({
    montoPagado: 0,
    fechaPago: "",
    estadoPago: "Pendiente",
    metodoPago:""
  });

  const [metodos, setMetodos] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const handleCloseSuccess = () => {
  setShowSuccess(false);
  handleClose(); // 🔁 cerramos el modal padre
};


  useEffect(() => {
    if (viaje?._id) {
      setForm({
        montoPagado: viaje.montoPagado || 0,
        fechaPago: viaje.fechaPago
          ? moment(viaje.fechaPago).format("YYYY-MM-DD")
          : "",
        estadoPago: viaje.estadoPago || "Pendiente",
        metodoPago: viaje.metodoPago?._id || "", // 👈 importante

      });
    }
  }, [viaje]);

  useEffect(() => {
    getMetodos().then((data) => {
      setMetodos(data);
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "montoPagado" ? parseFloat(value) : value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    montoPagado: form.montoPagado,
    fechaPago: form.fechaPago ? new Date(form.fechaPago) : null,
    estadoPago: form.estadoPago,
    metodoPago: form.metodoPago || null,

  };

  try {
    const resp = await putViaje(viaje._id, payload);

    setShowSuccess(true); // ✅ mostrar modal de éxito siempre

    setTimeout(() => {
      handleCloseSuccess(); // ⬅️ llamamos función aparte
    }, 2000);
  } catch (err) {
    console.error("❌ Error al guardar pago:", err);
  }
};



  const calcularLiquidacionFinal = (v) => {
  if (!v) return 0;
  const kmTableros = (v.combustible || [])
    .map((c) => Number(c.kmTablero))
    .filter((km) => !isNaN(km));
  const totalKm = kmTableros.length >= 2 ? Math.max(...kmTableros) - Math.min(...kmTableros) : 0;
  const tarifa = Number(v.tarifaPorKm || 130);
  const totalViaticos = (v.viaticos || []).reduce((sum, val) => sum + Number(val.monto || 0), 0);
  const totalAdelantos = (v.adelantos || []).reduce((sum, val) => sum + Number(val.monto || 0), 0);
  const totalGastos = (v.gastos || []).reduce((sum, val) => sum + Number(val.monto || 0), 0);
  const liquidacionFinal1 = (totalKm * tarifa) + totalViaticos;
  const liquidacionFinal2 = totalAdelantos - totalGastos;
  return liquidacionFinal1 - liquidacionFinal2;
};


  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              Registrar Pago - Viaje N° {viaje?.nroViaje || "-"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>💰 Liquidación Final</label>
              <input
                type="text"
                className="form-control"
                value={calcularLiquidacionFinal(viaje).toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}

                readOnly
              />
            </div>
            <div className="form-group">
              <label>Monto Pagado</label>
              <input
                type="number"
                name="montoPagado"
                className="form-control"
                value={form.montoPagado}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Fecha de Pago</label>
              <input
                type="date"
                name="fechaPago"
                className="form-control"
                value={form.fechaPago}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Estado de Pago</label>
              <select
                name="estadoPago"
                className="form-control"
                value={form.estadoPago}
                onChange={handleChange}
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Pagado">Pagado</option>
              </select>
            </div>
            <div className="form-group">
              <label>Método de Pago</label>
              <select
                name="metodoPago"
                className="form-control"
                value={form.metodoPago}
                onChange={handleChange}
              >
                <option value="">Seleccione un método</option>
                  {Array.isArray(metodos) &&
                    metodos.map((m) => (
                      <option key={m._id} value={m._id}>
                        {m.metodo}
                      </option>
                    ))}

              </select>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="success">
              Guardar Pago
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>

    </>
  );
}
